import requester from '@/utils/request'
export default {
  // 首页 nft 统计
  nftSummary: () => requester.get('/nft/v1/summary', {}, { headers: { isSeller: true } }),
  // 获取创作者的销售记录（分页）
  // @deprecated
  tradePage: (params: any) => requester.post('/sale/v1/querySalesRecord', params, { headers: { isSeller: true } }),
  queryCreatorPayments: (params: any) => requester.post('/sale/v1/payment/page', params, { headers: { isSeller: true } }),
  queryUserPayments: (params: any) => requester.post('/user/common/v1/payment/page', params),
  // 首页获取全局弹框配置
  getGlobalPopUp: () => requester.get('/common/global-pop-up/getGlobalPopUp', {}, { headers: { isSeller: true } }),
  // 首页 弹框后回调
  triggerPopUp: (data: any) => requester.post('/common/global-pop-up/triggerPopUp', data, { headers: { isSeller: true } }),
  // 总收入、可提现金额、关注者数量、nft持有者数量
  queryCreatorBenefits: (data: any) => requester.post('/wallet/v1/queryCreatorBenefits', data, { headers: { isSeller: true } }),
  guideInfo: () => requester.post('/creator/v1/guide', {}, { headers: { isSeller: true } }),
  closeGuide: () => requester.post('/creator/v1/closeGuide', {}, { headers: { isSeller: true } }),
}
